import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { YouTubePlayerModule } from "@angular/youtube-player";
import {
  NbActionsModule,
  NbBadgeModule,
  NbButton,
  NbButtonModule,
  NbCardModule,
  NbIconModule,
  NbProgressBarModule,
  NbRadioModule,
  NbSpinnerModule,
  NbAccordionModule,
  NbTagModule,
  NbListModule,
  NbUserModule,
  NbTabsetModule,
  NbFormFieldModule,
  NbInputModule,
  NbCheckboxModule,
  NbSelectModule,
  NbMenuModule,
  NbAlertModule,
  NbLayoutModule,
  NbContextMenuModule,
  NbDatepickerModule,
  NbToggleModule,
  NbTimepickerModule,
  NbTooltipModule,
} from "@nebular/theme";
import { ThemeModule } from "../@theme/theme.module";
import { UploadImageComponent } from "./upload-image/upload-image.component";
import { ViewImageComponent } from "./view-image/view-image.component";
import { ViewVideoComponent } from "./view-video/view-video.component";
import { ViewTimeAgoComponent } from "./view-time-ago/view-time-ago.component";
import { DialogYesNoPromptComponent } from "./dialog-yesno-prompt/dialog-yesno-prompt.component";
import { DialogTitlePromptComponent } from "./dialog-title-prompt/dialog-title-prompt.component";
import { ViewPlaceholderComponent } from "./view-placeholder/view-placeholder.component";
import { ViewGalleryComponent } from "./view-gallery/view-gallery.component";
import { NgxValidationMessageComponent } from "./validation-message/validation-message.component";

import { DialogCustomerComponent } from "./dialog-customer/dialog-customer.component";
import { ViewCustomersComponent } from "./view-customers/view-customers.component";
import { ViewCustomerComponent } from "./view-customers/view-customer/view-customer.component";

import { DialogHistoryComponent } from "./dialog-history/dialog-history.component";
import { ViewHistoryComponent } from "./view-histories/view-history/view-history.component";
import { ViewHistoriesComponent } from "./view-histories/view-histories.component";
import { HistoryService } from "../services/history.service";
import { ViewTagsComponent } from "./view-tags/view-tags.component";
import { DialogGalleryComponent } from "./dialog-gallery/dialog-gallery.component";
import { DialogImagesUploadComponent } from "./dialog-images-upload/dialog-images-upload.component";
import { EditorDocumentComponent } from "./editor-document/editor-document.component";
import { ViewDocumentComponent } from "./view-document/view-document.component";
import { ViewRatingStarComponent } from "./view-rating-star/view-rating-star.component";
import { ViewUserCardComponent } from "./view-user-card/view-user-card.component";
import { ViewUserDisplayComponent } from "./view-user-display/view-user-display.component";
import { DialogProfileComponent } from "./dialog-profile/dialog-profile.component";
import { ViewProfileComponent } from "./view-profile/view-profile.component";
import { UserService } from "../@core/services/user.service";

import { CKEditorModule } from "@ckeditor/ckeditor5-angular";
import { DialogProductComponent } from "./dialog-product/dialog-product.component";
import { ViewProductsComponent } from "./view-products/view-products.component";
import { ViewProductComponent } from "./view-products/view-product/view-product.component";
import { NgImageSliderModule } from "ng-image-slider";
import { ViewCatalogsComponent } from "./view-catalogs/view-catalogs.component";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { Ng2SmartTableModule } from "ng2-smart-table";
import { DialogLinkCatalogComponent } from "./dialog-link-catalog/dialog-link-catalog.component";

import { ViewTableProductsComponent } from "./view-table-products/view-table-products.component";
import { StbCustomRenderNumberComponent } from "./smart-table-customs/custom-render-number";
import { StbCustomEditorProductTitleComponent } from "./smart-table-customs/custom-editor-product-title.component";
import { StbCustomRenderButtonComponent } from "./smart-table-customs/custom-render-button";
import { DialogLinkCustomerComponent } from "./dialog-link-customer/dialog-link-customer.component";
import { DialogLinkReceiptComponent } from "./dialog-link-receipt/dialog-link-receipt.component";
import { ViewListProductsComponent } from "./view-list-products/view-list-products.component";
import { DialogPrintReceiptComponent } from "./dialog-print-receipt/dialog-print-receipt.component";
import { DialogReceiptDetailComponent } from "./dialog-receipt-detail/dialog-receipt-detail.component";

import { DialogFinanceComponent } from "./dialog-finance/dialog-finance.component";
import { CardValueOverviewComponent } from "./card-value-overview/card-value-overview.component";
import { FinanceChartComponent } from "./charts/finance-chart.component";
import { NgxEchartsModule } from "ngx-echarts";
import { ChartPanelHeaderComponent } from "./charts/chart-panel-header/chart-panel-header.component";
import { ChartLegendComponent } from "./charts/chart-legend/chart-legend.component";
import { DialogProductInventoryComponent } from "./dialog-product-inventory/dialog-product-inventory.component";
import { ViewListInventoriesComponent } from "./view-list-inventories/view-list-inventories.component";
import { DialogProductInventoriesComponent } from "./dialog-product-inventories/dialog-product-inventories.component";
import { NgxPaginationModule } from "ngx-pagination";
import { ViewTableReceiptsComponent } from "./view-table-receipts/view-table-receipts.component";
import { StbCustomRenderDateComponent } from "./smart-table-customs/custom-render-date";
import { DialogViewReceiptComponent } from "./dialog-view-receipt/dialog-view-receipt.component";
import { DialogReportReceiptsComponent } from "./dialog-report-receipts/dialog-report-receipts.component";
import { ViewTimePeriodComponent } from "./view-time-period/view-time-period.component";
import { StbCustomRenderCheckboxComponent } from "./smart-table-customs/custom-render-checkbox";
import { DialogReceiptCancelComponent } from "./dialog-receipt-cancel/dialog-receipt-cancel.component";
import { NgxPrintModule } from "ngx-print";
import { LayoutReceiptA4Component } from "./dialog-print-receipt/layout-receipt-a4/layout-receipt-a4.component";
import { LayoutReceiptPosComponent } from "./dialog-print-receipt/layout-receipt-pos/layout-receipt-pos.component";
import { StbCustomRenderIdComponent } from "./smart-table-customs/custom-render-id";
import { LayoutReceiptA4VFoodComponent } from "./dialog-print-receipt/layout-receipt-a4-vfood/layout-receipt-a4-vfood.component";
import { DialogPrintProductsComponent } from "./dialog-print-products/dialog-print-products.component";
import { LayoutPrintProductComponent } from "./dialog-print-products/layout-print-product/layout-print-product.component";
import { ViewTableInventoriesComponent } from "./view-table-inventories/view-table-inventories.component";
import { LayoutReceiptPosVFoodComponent } from "./dialog-print-receipt/layout-receipt-pos-vfood/layout-receipt-pos-vfood.component";
import { ViewTableFinancesComponent } from "./view-table-finances/view-table-finances.component";
import { DialogLinkPersonComponent } from "./dialog-link-person/dialog-link-person.component";
import { ViewSuppliersComponent } from "./view-suppliers/view-suppliers.component";
import { ViewSupplierComponent } from "./view-suppliers/view-supplier/view-supplier.component";
import { DialogSupplierComponent } from "./dialog-supplier/dialog-supplier.component";
import { ViewEmployeesComponent } from "./view-employees/view-employees.component";
import { ViewEmployeeComponent } from "./view-employees/view-employee/view-employee.component";
import { DialogEmployeeComponent } from "./dialog-employee/dialog-employee.component";
import { ViewPersonsComponent } from "./view-persons/view-persons.component";
import { ViewPersonComponent } from "./view-persons/view-person/view-person.component";
import { DialogPersonComponent } from "./dialog-person/dialog-person.component";
import { DialogLinkSupplierComponent } from "./dialog-link-supplier/dialog-link-supplier.component";
import { DialogPurchaseDetailComponent } from "./dialog-purchase-detail/dialog-purchase-detail.component";
import { DialogViewPurchaseComponent } from "./dialog-view-purchase/dialog-view-purchase.component";
import { ViewPurchaseComponent } from "./view-purchase/view-purchase.component";
import { ViewTablePurchasesComponent } from "./view-table-purchases/view-table-purchases.component";
import { DialogPrintPurchaseComponent } from "./dialog-print-purchase/dialog-print-purchase.component";
import { LayoutPurchaseA4Component } from "./dialog-print-purchase/layout-purchase-a4/layout-purchase-a4.component";
import { DialogPrintFinanceComponent } from "./dialog-print-finance/dialog-print-finance.component";
import { LayoutFinanceA4Component } from "./dialog-print-finance/layout-finance-a4/layout-finance-a4.component";
import { LayoutReceiptPosKaResComponent } from "./dialog-print-receipt/layout-receipt-pos-kares/layout-receipt-pos-kares.component";
import { LayoutReceiptA4StockVFoodComponent } from "./dialog-print-receipt/layout-receipt-a4-stock-vfood/layout-receipt-a4-stock-vfood.component";
import { LayoutReceiptA4StockComponent } from "./dialog-print-receipt/layout-receipt-a4-stock/layout-receipt-a4-stock.component";
import { ViewTableCrudProductsComponent } from "./view-table-crud-products/view-table-crud-products.component";
import { ViewWorkingTaskCardComponent } from "./view-working-task-card/view-working-task-card.component";

import { TranslateModule } from "@ngx-translate/core";
import { ViewBarcodeComponent } from "./view-barcode/view-barcode.component";
import { DialogPrintProductBarcodeComponent } from "./dialog-print-product-barcode/dialog-print-product-barcode.component";
import { NgxBarcodeModule } from "ngx-barcode";
import { DialogReceiptTradeHistoriesComponent } from "./dialog-receipt-trade-histories/dialog-receipt-trade-histories.component";
import { ViewTableCustomersComponent } from "./view-table-customers/view-table-customers.component";
import { DialogDeptCustomerComponent } from "./dialog-dept-customer/dialog-dept-customer.component";
import { DialogDeptSupplierComponent } from "./dialog-dept-supplier/dialog-dept-supplier.component";
import { ViewTableSuppliersComponent } from "./view-table-suppliers/view-table-suppliers.component";

import { ViewPaginationProductsComponent } from "./view-pagination-products-offline/view-pagination-products-offline.component";
import { DialogWorkingTaskComponent } from "./dialog-working-task/dialog-working-task.component";
import { ViewSelectionObjectComponent } from "./view-selection-object/view-selection-object.component";
import { DialogLinkObjectComponent } from "./dialog-link-object/dialog-link-object.component";
import { ViewTableWorkingsComponent } from "./view-table-workings/view-table-workings.component";
import { StbCustomRenderStatusComponent } from "./smart-table-customs/custom-render-status";
import { ViewCommentsComponent } from "./view-comments/view-comments.component";
import { StbCustomRenderPriorityComponent } from "./smart-table-customs/custom-render-priority";
import { DialogProjectComponent } from "./dialog-project/dialog-project.component";
import { ViewProjectsComponent } from "./view-projects/view-projects.component";
import { ViewProjectComponent } from "./view-projects/view-project/view-project.component";
import { StbCustomRenderObjectComponent } from "./smart-table-customs/custom-render-object";
import { DialogPrintDeptsComponent } from "./dialog-print-depts/dialog-print-depts.component";
import { DialogPrintDeptDetailsComponent } from "./dialog-print-dept-details/dialog-print-dept-details.component";
import { LayoutPrintDeptDetailComponent } from "./dialog-print-dept-details/layout-dept-detail/layout-dept-detail.component";
import { ExcelService } from "../@core/utils/excel.service";
import { ViewButtonExportExcelComponent } from "./view-button-export-excel/view-button-export-excel.component";
import { ViewInputNumberComponent } from "./view-input-number/view-input-number.component";
import { NgxNumberFormatModule } from "ngx-number-format";
import { LayoutPrintDeptDetailTamTaxComponent } from "./dialog-print-dept-details/layout-dept-detail-tamtax/layout-dept-detail-tamtax.component";
import { ViewTableReceiptDetailsComponent } from "./view-table-receipt-details/view-table-receipt-details.component";
import { DialogNotificationsComponent } from "./dialog-notifications/dialog-notifications.component";
import { ViewNotificationsComponent } from "./view-notifications/view-notifications.component";
import { ViewNotificationComponent } from "./view-notifications/view-notification/view-notification.component";
import { DialogProductOfflineComponent } from "./dialog-product-offline/dialog-product-offline.component";
import { LayoutReceiptA4PPDComponent } from "./dialog-print-receipt/layout-receipt-a4-ppd/layout-receipt-a4-ppd.component";
import { DialogRegisterComponent } from "./dialogs/dialog-register/dialog-register.component";
import { DialogAnnouncementComponent } from "./dialogs/dialog-announcement/dialog-announcement.component";
import { ViewAnnouncementsComponent } from "./view-announcements/view-announcements.component";
import { ViewAnnouncementComponent } from "./view-announcements/view-announcement/view-announcement.component";
import { StbCustomRenderProcessorComponent } from "./smart-table-customs/custom-render-processor";
import { ViewTableReceiptCustomersComponent } from "./view-table-receipt-customers/view-table-receipt-customers.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { ViewTableReceiptEmployeesComponent } from "./view-table-receipt-employees/view-table-receipt-employees.component";
import { DialogReceiptPromptComponent } from "./dialog-receipt-prompt/dialog-receipt-prompt.component";
import { ViewReceiptComponent } from "./view-receipt/view-receipt.component";
import { WindowGuideComponent } from "./windows/window-guide/window-guide.component";
import { StbCustomRenderStatusEditorComponent } from "./smart-table-customs/custom-render-status-editor";
import { DialogFinancePromptComponent } from "./dialogs/dialog-finance-prompt/dialog-finance-prompt.component";
import { ViewTableProductsReceiptComponent } from "./view-table-products-receipt/view-table-products-receipt.component";
import { LayoutReceiptA4DaiAnComponent } from "./dialog-print-receipt/layout-receipt-a4-daian/layout-receipt-a4-daian.component";
import { ViewTableReceiptDeliveryComponent } from "./view-table-receipt-delivery/view-table-receipt-delivery.component";
import { DialogReceiptDeliveryComponent } from "./dialog-receipt-delivery/dialog-receipt-delivery.component";
import { DialogPrintReceiptsDeliveryComponent } from "./dialogs/dialog-print-receipts-delivery/dialog-print-receipts-delivery.component";
import { ViewTablePaginationProductsComponent } from "./view-table-pagination-products/view-table-pagination-products.component";
import { LayoutPurchaseA4PPDComponent } from "./dialog-print-purchase/layout-purchase-a4-ppd/layout-purchase-a4-ppd.component";
import { DialogLoanComponent } from "./dialogs/dialog-loan/dialog-loan.component";
import { ViewLoanCoverComponent } from "./views/view-loan-cover/view-loan-cover.component";
import { DialogLinkProductComponent } from "./dialogs/dialog-link-product/dialog-link-product.component";
import { EditorDateTimeComponent } from "./ultils/editor-datetime/editor-datetime.component";
import { EditorDateComponent } from "./ultils/editor-date/editor-date.component";
import { DialogCustomerTaskComponent } from "./dialogs/dialog-customer-task/dialog-customer-task.component";
import { DialogViewTaskComponent } from "./dialogs/dialog-view-task/dialog-view-task.component";
import { DialogPrintWorkingTaskComponent } from "./dialogs/dialog-print-working-task/dialog-print-working-task.component";
import { ViewLoanRemindComponent } from "./views/view-loan-remind/view-loan-remind.component";
import { DialogDeptCustomerArchiveComponent } from "./dialogs/dialog-dept-customer-archive/dialog-dept-customer-archive.component";
import { DialogDeptSupplierArchiveComponent } from "./dialogs/dialog-dept-supplier-archive/dialog-dept-supplier-archive.component";
import { DialogProductInventoriesArchiveComponent } from "./dialogs/dialog-product-inventories-archive/dialog-product-inventories-archive.component";
import { ViewTableReceiptOrderComponent } from "./view-table-receipt-order/view-table-receipt-order.component";
import { DialogViewReceiptOrderComponent } from "./dialogs/dialog-view-receipt-order/dialog-view-receipt-order.component";
import { DialogPrintReceiptOrderComponent } from "./dialogs/dialog-print-receipt-order/dialog-print-receipt-order.component";
import { ViewTableReceiptInventoryComponent } from "./view-table-receipt-inventories/view-table-receipt-inventories.component";
import { ViewReceiptProductsComponent } from "./view-receipt-products/view-receipt-products.component";
import { DialogShareLinkComponent } from "./dialogs/dialog-share-link/dialog-share-link.component";
import { ViewQRCodeComponent } from "./ultils/view-qrcode/view-qrcode.component";
import { QRCodeModule } from "angularx-qrcode";

const COMPONENTS = [
  NgxValidationMessageComponent,
  // NgxFilterByNumberComponent,
  UploadImageComponent,
  ViewImageComponent,
  ViewVideoComponent,
  DialogYesNoPromptComponent,
  DialogTitlePromptComponent,
  ViewTimeAgoComponent,
  ViewTimePeriodComponent,
  ViewTagsComponent,
  ViewProfileComponent,
  ViewBarcodeComponent,
  ViewSelectionObjectComponent,
  DialogLinkObjectComponent,
  ViewPlaceholderComponent,

  DialogRegisterComponent,

  //Customer
  ViewGalleryComponent,
  DialogCustomerComponent,
  ViewCustomersComponent,
  ViewCustomerComponent,
  ViewTableCustomersComponent,
  DialogDeptCustomerComponent,
  DialogPrintDeptsComponent,
  DialogHistoryComponent,
  ViewHistoriesComponent,
  ViewHistoryComponent,
  DialogGalleryComponent,
  DialogImagesUploadComponent,
  EditorDocumentComponent,
  ViewDocumentComponent,
  ViewRatingStarComponent,
  ViewUserCardComponent,
  ViewUserDisplayComponent,
  DialogProfileComponent,
  DialogCustomerTaskComponent,
  DialogDeptCustomerArchiveComponent,

  //Product
  DialogProductComponent,
  ViewProductsComponent,
  ViewProductComponent,
  ViewCatalogsComponent,
  DialogLinkCatalogComponent,
  DialogPrintProductBarcodeComponent,
  DialogLinkProductComponent,

  ViewReceiptComponent,
  ViewTableProductsComponent,
  ViewTablePaginationProductsComponent,
  DialogLinkCustomerComponent,
  DialogLinkReceiptComponent,
  ViewListProductsComponent,
  ViewTableCrudProductsComponent,
  ViewPaginationProductsComponent,
  DialogProductOfflineComponent,
  DialogProductInventoriesArchiveComponent,

  //Layout Print Receipt
  DialogPrintReceiptComponent,
  LayoutReceiptA4Component,
  LayoutReceiptA4VFoodComponent,
  LayoutReceiptPosComponent,
  LayoutReceiptPosVFoodComponent,
  LayoutReceiptA4StockVFoodComponent,
  LayoutReceiptA4StockComponent,
  LayoutReceiptPosKaResComponent,
  LayoutReceiptA4PPDComponent,
  LayoutReceiptA4DaiAnComponent,

  ViewTableReceiptEmployeesComponent,
  ViewTableReceiptCustomersComponent,
  DialogReceiptDetailComponent,
  ViewTableReceiptsComponent,
  ViewTableReceiptDeliveryComponent,
  DialogViewReceiptComponent,
  DialogReportReceiptsComponent,
  DialogReceiptCancelComponent,
  ViewTableProductsReceiptComponent,
  DialogPrintReceiptsDeliveryComponent,
  DialogViewReceiptOrderComponent,
  DialogPrintReceiptOrderComponent,

  //Finance
  DialogFinanceComponent,
  ViewTableFinancesComponent,
  DialogPrintFinanceComponent,
  LayoutFinanceA4Component,
  DialogFinancePromptComponent,

  CardValueOverviewComponent,
  //inventories
  DialogProductInventoryComponent,
  ViewListInventoriesComponent,
  DialogProductInventoriesComponent,
  ViewTableInventoriesComponent,

  DialogPrintProductsComponent,
  LayoutPrintProductComponent,

  //Person
  DialogLinkPersonComponent,
  DialogPersonComponent,
  ViewPersonsComponent,
  ViewPersonComponent,

  //Supplier
  ViewSuppliersComponent,
  ViewSupplierComponent,
  DialogSupplierComponent,
  DialogLinkSupplierComponent,
  DialogDeptSupplierComponent,
  ViewTableSuppliersComponent,
  DialogDeptSupplierArchiveComponent,

  //Employee
  ViewEmployeesComponent,
  ViewEmployeeComponent,
  DialogEmployeeComponent,

  //Chart
  FinanceChartComponent,
  ChartPanelHeaderComponent,
  ChartLegendComponent,

  //Purchase
  ViewPurchaseComponent,
  DialogPurchaseDetailComponent,
  DialogViewPurchaseComponent,
  ViewTablePurchasesComponent,
  DialogPrintPurchaseComponent,
  LayoutPurchaseA4Component,
  LayoutPurchaseA4PPDComponent,

  //Loan
  DialogLoanComponent,
  ViewLoanCoverComponent,
  ViewLoanRemindComponent,

  //trade
  DialogReceiptTradeHistoriesComponent,
  DialogPrintDeptDetailsComponent,
  LayoutPrintDeptDetailComponent,
  LayoutPrintDeptDetailTamTaxComponent,
  ViewTableReceiptDetailsComponent,
  DialogReceiptPromptComponent,
  DialogReceiptDeliveryComponent,
  ViewTableReceiptOrderComponent,
  ViewTableReceiptInventoryComponent,
  ViewReceiptProductsComponent,

  //Working-tasks
  ViewWorkingTaskCardComponent,
  DialogWorkingTaskComponent,
  ViewTableWorkingsComponent,
  ViewCommentsComponent,
  DialogViewTaskComponent,
  DialogPrintWorkingTaskComponent,

  //Project
  DialogProjectComponent,
  ViewProjectsComponent,
  ViewProjectComponent,

  //Notifications
  DialogNotificationsComponent,
  ViewNotificationsComponent,
  ViewNotificationComponent,

  //announcement
  DialogAnnouncementComponent,
  ViewAnnouncementsComponent,
  ViewAnnouncementComponent,

  //Windows
  WindowGuideComponent,

  //smart-table
  StbCustomRenderNumberComponent,
  StbCustomRenderDateComponent,
  StbCustomEditorProductTitleComponent,
  StbCustomRenderButtonComponent,
  StbCustomRenderCheckboxComponent,
  StbCustomRenderIdComponent,
  StbCustomRenderStatusComponent,
  StbCustomRenderPriorityComponent,
  StbCustomRenderObjectComponent,
  StbCustomRenderStatusEditorComponent,

  //Buttons
  ViewButtonExportExcelComponent,
  ViewInputNumberComponent,

  //Ultimate
  EditorDateTimeComponent,
  EditorDateComponent,
  ViewQRCodeComponent,
  DialogShareLinkComponent,
];

const ENTRY_COMPONENTS = [
  // NgxFilterByNumberComponent,
  StbCustomRenderNumberComponent,
  StbCustomRenderDateComponent,
  StbCustomEditorProductTitleComponent,
  StbCustomRenderButtonComponent,
  StbCustomRenderCheckboxComponent,
  StbCustomRenderIdComponent,
  StbCustomRenderProcessorComponent,
];

@NgModule({
  imports: [
    ThemeModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    NbCardModule,
    NbSpinnerModule,
    NbButtonModule,
    NbIconModule,
    NbRadioModule,
    NbActionsModule,
    NbBadgeModule,
    YouTubePlayerModule,
    CKEditorModule,
    NbProgressBarModule,
    NbAccordionModule,
    NbTagModule,
    NbListModule,
    NbUserModule,
    NbTabsetModule,
    NbInputModule,
    NbFormFieldModule,
    NbCheckboxModule,
    NbSelectModule,
    NbMenuModule,
    NbAlertModule,
    NbIconModule,
    NbLayoutModule,
    NbToggleModule,
    NbContextMenuModule,
    NgImageSliderModule,
    Ng2SearchPipeModule,
    Ng2SmartTableModule,
    NbDatepickerModule,
    NbTimepickerModule,
    NgxEchartsModule,
    NgxPaginationModule,
    NgxPrintModule,
    TranslateModule,
    NgxBarcodeModule,
    NgxNumberFormatModule,
    NgSelectModule,
    QRCodeModule,
    NbTooltipModule,
  ],
  exports: [...COMPONENTS],
  declarations: [...COMPONENTS],
  entryComponents: [...ENTRY_COMPONENTS],
  providers: [UserService, HistoryService, ExcelService],
})
export class ComponentsModule {}
